class GetLeadError extends Error {
  constructor(cause, url, props, code = 'GET_LEAD_ERROR') {
    super("Falha ao salvar dados do lead");
    this.name = 'GetLeadError';
    this.code = code;
    this.cause = cause;
    this.url = url;
    this.props = props;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GetLeadError);
    }
  }
}

module.exports = GetLeadError;